define('instrumentation/ariaApplicationLogFormatter', [
  'lib/underscore',
  'instrumentation/log-category',
  'instrumentation/util',
  'instrumentation/event-formatter'
], function (_, LOGCATEGORY, util, EventFormatter) {
  var bracketedParamsRegex = /\([^)]*\)/g;

  function safeParseInteger(number) {
    var parsedNum = Number(number);

    if (_.isNaN(parsedNum) || parsedNum < 0) {
      return 0;
    }
    return Math.round(parsedNum);
  }

  function convertAbsoluteToRelativePath(log) {
    var path = log.Api.toLowerCase();

    if ((path.indexOf('http://') !== 0) && (path.indexOf('https://') !== 0)) {
      return log;
    }

    var a = document.createElement('a');

    a.href = path;
    log.Api = a.pathname;
    if (log.Api.indexOf('/') === 0 && log.Api.length > 1) {
      log.Api = log.Api.substring(1);
    }

    return log;
  }

  function commonLogFormatter(rawLog, options) {
    return {
      LogID: rawLog.logId,
      Sn: rawLog.scenarioName || '',
      SceID: rawLog.scenarioId || '',
      RID: rawLog.requestId || '',
      Api: _.isString(rawLog.api) ? rawLog.api.trim().toLowerCase() : '',
      Pass: _.isUndefined(rawLog.pass) ? '' : rawLog.pass,
      Dur: safeParseInteger(rawLog.timeTaken),
      Ime: _.isUndefined(rawLog.isMethodEnter) ? '' : rawLog.isMethodEnter,
      Hm: rawLog.httpMethod || '',
      Timestamp: rawLog.timeStamp,
      SesID: rawLog.sessionId || '',
      UID: rawLog.userId || '',
      CID: rawLog.customerId || '',
      AID: rawLog.accountId || '',
      LCID: rawLog.lcid || '',
      Mes: JSON.stringify(rawLog.message),
      Lc: _.isArray(rawLog.logCategory) ?
      rawLog.logCategory.join(',') : rawLog.logCategory,
      Ll: rawLog.logLevel ? rawLog.logLevel.name : '',
      Device: rawLog.device || '',
      Url: rawLog.url || '',
      Env: window.location.hostname,
      As: options && options.applicationSystem ? options.applicationSystem : '',
      Asub: rawLog.appSubSystemName || '',
      An: rawLog.activityName || '',
      ActID: rawLog.activityId || '',
      Et: rawLog.entryType || '',
      Loc: rawLog.market || '',
      Role: rawLog.userRole || '',
      MgdBy: rawLog.managedBy || '',
      PFlags: rawLog.pilots || '',
      Iu: rawLog.impactUser || options.constants.IMPACTUSER.NA,
      Ec: safeParseInteger(rawLog.entityCount),
    };
  };

  var extraFormatters = {};
  extraFormatters[LOGCATEGORY.CLICKEVENT] = EventFormatter.clickEventLogFormatter;
  extraFormatters[LOGCATEGORY.INPUTCHANGEEVENT] = EventFormatter.inputChangeEventLogFormatter;
  extraFormatters[LOGCATEGORY.KEYBOARDEVENT] = EventFormatter.keyboardEventLogFormatter;
  extraFormatters[LOGCATEGORY.ROUTECHANGEEVENT] = EventFormatter.routeChangeEventLogFormatter;

  return {
    formatLog: function(rawLog, options) {
      var formattedLog = commonLogFormatter(rawLog, options);

      if (_.isString(rawLog.logCategory) && extraFormatters[rawLog.logCategory]) {
        return _.extend(formattedLog, extraFormatters[rawLog.logCategory](rawLog));
      }

      return formattedLog;
    },
  };
});